import { ValidateType } from './validation.types';

export const compose =
  <V>(validators: (ValidateType | undefined)[]) =>
  (value: V, allValues: object) => {
    const result = validators.reduce(
      (error: unknown, validator?: ValidateType) =>
        error || validator?.(value, allValues),
      undefined,
    );

    return result;
  };

/**
 * Компонует массив валидаторов предупреждений в одну функцию,
 * которая собирает все предупреждения вместо остановки на первом.
 *
 * @param validators - Массив функций-валидаторов
 * @returns Функция, возвращающая массив всех сработавших предупреждений
 */
export const composeWarnings =
  (validators: (ValidateType | undefined)[]) =>
  async (
    value: Record<string, unknown> | unknown,
    allValues: Record<string, unknown>,
  ): Promise<string[]> => {
    const warnings: string[] = [];

    for (const validator of validators) {
      if (validator) {
        const result = await validator(value, allValues);
        if (result) {
          warnings.push(result);
        }
      }
    }

    return warnings;
  };
